import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const SATISPAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Satispay,
    name: 'satispay',
    displayName: 'Satispay'
};
